var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.display ? 'sai-mobile-modal show' : 'sai-mobile-modal'},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-close-container",on:{"click":_vm.closeModal}},[_c('span',{staticClass:"close-icon"},[_vm._v("✖")])]):_vm._e(),_c('div',{staticClass:"mobile-modal-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }